import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../../Config/firebase";
import { getUsuarioAtualComTenant, tenantWhere } from "../../Utils/tenant";

export async function calcularRQ13() {
  const usuario = await getUsuarioAtualComTenant();
  const snap = await getDocs(
    query(
      collection(db, "kpi_eventos"),
      ...tenantWhere(usuario)
    )
  );
  const hojeISO = new Date().toISOString().slice(0, 10);

  const indicadores = {
    // gerais
    total: 0,
    totalNC: 0,
    totalMelhorias: 0,

    // status NC
    ncAbertas: 0,
    ncEmAndamento: 0,
    ncEncerradas: 0,
    ncForaPrazo: 0,

    // classificação NC
    ncLeve: 0,
    ncModerada: 0,
    ncGrave: 0,

    // 👉 NC POR TIPO (DINÂMICO)
    ncPorTipo: {}
  };

  snap.forEach(doc => {
    const e = doc.data();
    indicadores.total++;

    /* =====================
       NÃO CONFORMIDADES
    ===================== */
    if (e.tipoRegistro === "NC") {
      indicadores.totalNC++;

      // STATUS
      if (e.status === "Aberta") indicadores.ncAbertas++;
      if (e.status === "Em andamento") indicadores.ncEmAndamento++;
      if (e.status === "Encerrada") indicadores.ncEncerradas++;

      // CLASSIFICAÇÃO
      if (e.classificacao === "Leve") indicadores.ncLeve++;
      if (e.classificacao === "Moderada") indicadores.ncModerada++;
      if (e.classificacao === "Grave") indicadores.ncGrave++;

      // FORA DO PRAZO
      if (
        e.status !== "Encerrada" &&
        e.prazo &&
        hojeISO > e.prazo
      ) {
        indicadores.ncForaPrazo++;
      }

      // 👉 TIPO DE NC (100% DINÂMICO + NORMALIZADO)
      if (e.tipoNC) {
        const tipo = e.tipoNC.trim();

        indicadores.ncPorTipo[tipo] =
          (indicadores.ncPorTipo[tipo] || 0) + 1;
      }
    }

    /* =====================
       MELHORIAS
    ===================== */
    if (e.tipoRegistro === "MELHORIA") {
      indicadores.totalMelhorias++;
    }
  });

  return indicadores;
}
